import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getVoteResultFailed,
  getVoteResultStart,
  getVoteResultSuccess,
} from "../redux/getVoteResult";

import { getVoteResultApi } from "core/http/service/internalEvents";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { PayloadAction } from "@reduxjs/toolkit";

function* getVoteResultWork(
  action: PayloadAction<{
    id: string;
    awardId: string;
    sort: string;
    limit?: string | number;
    offset?: string | number;
  }>
) {
  const { id, ...payload } = action.payload;
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));
  const params = {
    offset,
    limit,
    ...payload,
  };

  try {
    const res = yield call(getVoteResultApi, params);

    yield put({
      type: getVoteResultSuccess.type,
      payload: {
        id,
        data: res.data,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getVoteResultFailed.type,
      payload: {
        id,
      },
    });
  }
}

function* watchGetVoteResult() {
  yield takeEvery(getVoteResultStart.type, getVoteResultWork);
}

export default function* getVoteResultSaga() {
  yield all([watchGetVoteResult()]);
}
